import { produce } from 'immer';
import { AnyAction, Reducer } from 'redux';

import { IReducer } from '../interfaces/IReducer';

export function createCombinedReducer<TState> (reducers: IReducer<TState>[], initialState: TState): Reducer<TState> {
    return (state: TState | undefined, action: AnyAction): TState => {
        if (state === undefined) {
            return initialState;
        }

        if (!action.type || !action.namespace || !action.hasOwnProperty('payload')) {
            return state;
        }

        return produce(state, (draft: TState): void => {
            reducers.forEach((reducer: IReducer<TState>) => {
                reducer(draft, action);
            });
        });
    };
}